import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    dropdown: '',
    itemsWrapper: 'p-1 flex w-full box-border',
  },
}));
